export default __webpack_public_path__ + "static/media/success.a7fa9724.wav";